import { format } from 'date-fns';

export { cn } from './cn';


export const onlyNumbers = (input: any) => {
    return `${input}`.replace(/\D/g, '');
};

/**
 * checks if the value and symbols are in English, all symbols are English
 * @example
 *  isEnglishValue('123') // true
 *  isEnglishValue('123abc') // false
 *  isEnglishValue('abc') // true
 *  isEnglishValue('abc123') // true
 *  isEnglishValue('אבג') // false
 *  isEnglishValue('אבג123') // false
 *  isEnglishValue('(124) 124-1241') // true
 * @param value any
 * @returns 
 */
export const isEnglishValue = (value?: any) => {
    if (!value) {
        return true;
    }
    const englishPattern = /^[a-zA-Z0-9\s!@#$%^&*()_\-+={}[\]|\\:;"'<>,.?/~`]*$/;
    return englishPattern.test(value);
};

export const getTextDirection = (value?: any, defaultVal?: 'left' | 'right' | 'center') => {
    if (!value) {
        return defaultVal || 'right';
    }
    const isValueEng = isEnglishValue(value);
    return isValueEng ? 'left' : 'right';
};

export const getDirection = (value?: any, defaultVal?: 'ltr' | 'rtl') => {
    if (!value) {
        return defaultVal || 'rtl';
    }
    const isValueEng = isEnglishValue(value);
    return isValueEng ? 'ltr' : 'rtl';
};
export const generateTempPassword = (length = 6) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let password = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        password += chars[randomIndex];
    }
    return password;
};

export const randomColor = (mode?: 'light' | 'dark') => {
    if (mode === 'light') {
        const darkBackgroundColors = [
            '#003366', '#00264D', '#1C1C1C', '#1B2631', '#212F3C',
            '#283747', '#2E4053', '#34495E', '#1A5276', '#154360',
            '#186A3B', '#145A32', '#0E6655', '#0B5345', '#2C3E50',
            '#424949', '#4A235A', '#512E5F', '#5B2C6F', '#6C3483',
            '#7D3C98', '#884EA0', '#76448A', '#633974', '#4D5656',
            '#1B4F72', '#2874A6', '#5499C7', '#48C9B0', '#1ABC9C',
            '#16A085', '#117A65', '#0E6251', '#0B5345', '#186A3B',
            '#239B56', '#27AE60', '#52BE80', '#229954', '#28B463'
        ];
        
        return darkBackgroundColors[Math.floor(Math.random() * darkBackgroundColors.length)];        

    }
    const lightBackgroundColors = [
        '#FFEBE5', '#FFF7CC', '#FFF1D6', '#FDF2E9', '#FFEFD5',
        '#E7F0FF', '#E5F5E0', '#F0F7D4', '#E6F5F8', '#EAF2FF',
        '#F9E9E9', '#FAF1F0', '#F5F0FF', '#FFE6F7', '#FFF0FF',
        '#F0FFE6', '#E6FFF2', '#E6FFF0', '#FFF8E6', '#FFF7E8',
        '#F9FBEF', '#EFF9F6', '#F2FFEB', '#EBFFFA', '#FFF4F4',
        '#FFE6EB', '#E6FAFF', '#E8FFF4', '#FFF4E6', '#FFECE6',
        '#FFF5E0', '#E6F9FF', '#E6F8FF', '#FFFAE6', '#FFFBEA',
        '#F0E6FF', '#FFE6FA', '#FFE8F8', '#E6FFF8', '#EAF9FF'
    ];
    
    return lightBackgroundColors[Math.floor(Math.random() * lightBackgroundColors.length)];
};

export const toLocalDateString = (timestamp: number) => {
    const date = new Date(timestamp);
    return format(date, 'MMM dd, yyyy');
};

export const toFriendlyURI = (title: string): string => {
    return title
        .replace(/[^a-zA-Z0-9\s'-]/g, '')
        .replace(/\s+/g, '-');
};


export const createThumbnail = async (file: File): Promise<File> => {
    const img = new Image();
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onload = () => {
            img.onload = () => {
                const size = 160;
                canvas.width = size;
                canvas.height = size;

                if (ctx) {
                    const scale = Math.min(size / img.width, size / img.height);
                    const x = (size - img.width * scale) / 2;
                    const y = (size - img.height * scale) / 2;

                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(img, x, y, img.width * scale, img.height * scale);

                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                resolve(new File([blob], file.name, { type: file.type }));
                            } else {
                                reject(new Error('Could not create thumbnail'));
                            }
                        },
                        file.type,
                        1
                    );
                } else {
                    reject(new Error('Could not get canvas context'));
                }
            };

            img.onerror = (e) => reject(e);
            img.src = reader.result as string;
        };

        reader.onerror = (e) => reject(e);
        reader.readAsDataURL(file);
    });
};
export function getQueryParam(queryName: string): string {
    const params = new URLSearchParams(window.location.search);
    return params.get(queryName) || '';
}

